/** @format */
import { ReactNode } from 'react';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CardBackgroundColor {
    WHITE = 'white',
    MIDNIGHT = 'midnight',
    SKY = 'sky',
    SUSTAINABILITY = 'sustainability',
    PINK = 'pink',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledCardBackgroundProps = {
    color?: CardBackgroundColor;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    expandOnHover?: boolean;
    tag?: string;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CardBackgroundProps = StyledCardBackgroundProps & {
    children?: ReactNode;
    className?: string;
    'data-testid'?: string;
};
